import { useInView } from 'react-intersection-observer'

import classnames from 'classnames'

import Fixture from '~/components/atoms/Fixture/Fixture'
import { ComponentTheme } from '~/components/themes'

import Text, { TextSizes } from '../Text/Text'

import styles from './Quote.module.css'

export interface QuoteProps {
  _key: string
  title: string
  author?: string
  theme?: ComponentTheme
  verticalPadding?: boolean
  noPaddingBottom?: boolean
  testID?: string
  moduleId?: string
}

export default function Quote({
  _key,
  title,
  author,
  theme = ComponentTheme.primary,
  verticalPadding,
  noPaddingBottom,
  testID,
  moduleId,
}: QuoteProps) {
  const [ref, inView] = useInView({
    triggerOnce: true,
  })

  return (
    <Fixture
      theme={theme}
      verticalPadding={verticalPadding}
      noPaddingBottom={noPaddingBottom}
      id={moduleId}
    >
      <div
        className={classnames(styles.base, inView && styles.inview)}
        data-testid={testID}
        ref={ref}
        id={_key}
      >
        <div className={styles.inner}>
          <div className={styles.title}>
            <Text
              size={TextSizes.magSecondaryTitleLrg}
              className={styles.quoteTitle}
            >
              {title}
            </Text>
          </div>

          <Text
            size={TextSizes.bodyMed}
            uppercase={true}
            className={styles.author}
          >
            {author}
          </Text>
        </div>
      </div>
    </Fixture>
  )
}
